module.exports = __webpack_public_path__ + "static/homeBanner-d113ae88467a17bcafab16a97ddf9e76.png";